import { render, staticRenderFns } from "./PriceTag.vue?vue&type=template&id=160aa78e&scoped=true"
import script from "./PriceTag.vue?vue&type=script&lang=js"
export * from "./PriceTag.vue?vue&type=script&lang=js"
import style0 from "./PriceTag.vue?vue&type=style&index=0&id=160aa78e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160aa78e",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fprice-tag%2FPriceTag.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports